import { render, staticRenderFns } from "./DisplayPoduct.vue?vue&type=template&id=46c9c9aa&scoped=true&"
import script from "./DisplayPoduct.vue?vue&type=script&lang=js&"
export * from "./DisplayPoduct.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPoduct.vue?vue&type=style&index=0&id=46c9c9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c9c9aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c9c9aa')) {
      api.createRecord('46c9c9aa', component.options)
    } else {
      api.reload('46c9c9aa', component.options)
    }
    module.hot.accept("./DisplayPoduct.vue?vue&type=template&id=46c9c9aa&scoped=true&", function () {
      api.rerender('46c9c9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlinePrinting/DisplayPoduct/DisplayPoduct.vue"
export default component.exports